export enum TransactionsSteps {
  FutureTransactions = 'futureTransactions',
  Statement = 'statement'
}
